import { render } from "./auth-layout.vue?vue&type=template&id=1fba3600"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/auth-layout/auth-layout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fba3600"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fba3600', __exports__)) {
    api.reload('1fba3600', __exports__)
  }
  
  module.hot.accept("./auth-layout.vue?vue&type=template&id=1fba3600", () => {
    api.rerender('1fba3600', render)
  })

}


export default __exports__